import React from 'react';
import { motion } from 'framer-motion';
import { useTranslation } from 'react-i18next';

const SlideText = () => {
  // useTranslation hook'u ile t fonksiyonunu alıyoruz.
  const { t } = useTranslation();

  return (
    // Ana kapsayıcı; sayfanın alt kısmında, yarı saydam siyah arka plan
    <div className='w-full absolute bottom-0 left-0 bg-[rgba(0,0,0,0.7)] z-20 py-3 overflow-hidden'>
      {/* Hareketli metin kapsayıcısı */}
      <motion.div
        className='flex whitespace-nowrap'
        initial={{ x: '100%' }}
        animate={{ x: '-100%' }}
        transition={{
          repeat: Infinity,       // Sonsuz tekrar
          repeatType: 'loop',     // Döngüsel tekrar
          duration: 20,           // Metnin akış hızı (daha büyük sayı = daha yavaş)
          ease: 'linear',
        }}
      >
        {/* Çeviri ile dinamik metin */}
        <h1 className='text-white text-20 tracking-widest mr-8'>
          {t('slideText.content')}
        </h1>
      </motion.div>
    </div>
  );
};

export default SlideText;
